<template>
  <div class="new_course_render" id="new_course_render">
<!--    <div class="currentValueName" v-if="![10, 11].includes(currentValue.szrtType)">-->
     <div class="currentValueName">
      <span v-if="currentValue.name || currentValue.tagName"
            style="justify-content: center; display: flex;align-items: center;">
<!--         <span-->
<!--           v-if="currentValue.name && currentValue.showFlag && showTopCurrentValueName"-->
<!--           :title="currentValue.name"-->
<!--           class=" new_course_render_name editorShowArea ql-editor"-->
<!--           v-html="currentValue.name">-->
<!--         </span>-->

         <div class="item-table" v-if="currentValue.tagName === '共享资源'">
            <el-table
                v-loading="loading"
                class="table"
                ref="multipleTable"
                :data="tableData"
                stripe
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column type="index" label="序号" width="60">
                  <template
                    slot-scope="scope">{{ (pageTotal.page - 1) * pageTotal.pageSize + scope.$index + 1 }}</template>
                </el-table-column>
                <el-table-column prop="name" label="文件名称" show-overflow-tooltip align="left"></el-table-column>
                <el-table-column prop="typeName" label="类型" width="150" align="left"></el-table-column>
                <el-table-column prop="sizeStr" label="大小" width="150" align="left">
                  <template slot-scope="scope">
                    {{ scope.row.type == 5 || scope.row.type == 6 ? "" : scope.row.sizeStr }}
                  </template>
                </el-table-column>
                <el-table-column prop="address" label="操作" width="150" align="left">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="table_previewBtn(scope.row)"
                    >预览</el-button
                    >
                    <el-button v-if="(scope.row.type != 5 && scope.row.type != 6) && scope.row.downloadFlag == 1"
                               type="text" size="mini" @click="table_downloadBtn(scope.row)"
                    >下载</el-button
                    >
                  </template>
                </el-table-column>
                <!-- null 列表 -->
                <div slot="empty" class="empty_material">
                  <img src="@/assets/image/sources/table_no_data.png" alt="加载失败"/>
                  <p>暂无数据</p>
                </div>
            </el-table>

            <Pagination
                :page="pageTotal.page"
                :limit="pageTotal.pageSize"
                :total="pageTotal.total"
                layout="total, sizes, prev, pager, next, jumper"
                @pagination="handleCurrentChange"
                :small="true"
            ></Pagination>
        </div>
         <span
           v-else-if="currentValue.showFlag && showTopCurrentValueName"
           style="padding-right: 10px"
           class=" new_course_render_name editorShowArea ql-editor"
           v-html="currentValue.tagName || currentValue.name ">
         </span>
         <template v-if="isShow && currentValue.taskType == 1 && userType > 1">
           <img v-if="currentValue.isFinish == 1" :src="isFinish" class="is_finish"/>
           <img v-else :src="unFinish" class="is_finish"/>
          </template>
      </span>

      <div class="currentValueBtn">
        <span
          v-if="userType <= 1 && currentValue.taskType == 1 && currentValue.resourceType===3 && (courseType == '3'&&(type==1||type==2||type==3))">
           允许查看答案
           <el-switch
             v-model="currentValue.show"
             :active-value="1"
             :inactive-value="0"
             @change="selectViewAnswers"
             active-color="#1890FF"
             inactive-color="#D2D2D7"
           ></el-switch>
        </span>
        <span
          v-if="isIT && currentValue.taskType == 1 && currentValue.resourceType===3 && (courseType == '3'&&(type==1||type==2||type==3))"
          class="currentValueBtn2" >
            <el-button v-if="userType !=2 || (currentValue.show && currentValue.isFinish == 1)" type="primary" size="mini"
                       @click="openReferenceAnswer">查看参考答案</el-button>
            <el-button :title="currentValue.show?'请作答后再查看答案':'老师未允许查看参考答案'" disabled v-else
                       type="primary" size="mini">查看参考答案</el-button>
            <el-button v-if="userType !=2 || (currentValue.show && currentValue.isFinish == 1)" type="primary" size="mini"
                       @click="openRatingDetails">评分详情</el-button>
        </span>
      </div>
    </div>
    <div class="showFileStyle" :style="projectType === 'native'?'background: #000000': ''" v-if="currentValue.szrtType == 1 || currentValue.szrtType == 2 || currentValue.szrtType == 8">
      <!-- ppt&pdf&word -->
      <!-- 本地部署，用 native 打包。用原生展示素材 -->
      <!--      <template v-if="projectType === 'native'">-->
      <!--        <div v-if="currentValue.szrtType == 1" id="pptxDiv"></div>-->
      <!--        <zl_pdf v-else-if="currentValue.szrtType == 2" :src="currentValue.newAttaUrl"></zl_pdf>-->
      <!--      </template>-->
      <!--      <iframe v-else-if="currentValue.szrtType == 1 || currentValue.szrtType == 2"-->
      <!--        id="pptIframe"-->
      <!--        style="width: 100%; height: 100%;"-->
      <!--        :src="iframeUrl"-->
      <!--        frameborder="0"-->
      <!--      ></iframe>-->

      <template v-if="currentValue.szrtType == 1 || currentValue.szrtType == 2">
<!--        <iframe v-if="projectType === 'native'"-->
<!--                style="width: 100%; height: 100%;"-->
<!--                :src="currentValue.convertUrl || currentValue.newAttaUrl"-->
<!--                frameborder="0"-->
<!--        ></iframe>-->

        <zl_pdf v-if="projectType === 'native'" :src="currentValue.convertUrl || currentValue.newAttaUrl"></zl_pdf>

        <iframe v-else
                id="pptIframe"
                style="width: 100%; height: 100%;"
                :src="iframeUrl"
                frameborder="0"
        ></iframe>
      </template>
      <template v-else>
        <iframe
          v-if="(currentValue.typeSuffix === 'xlsx' || currentValue.typeSuffix === 'xls')"
          style="width: 100%; height: 100%;"
          :src="iframeUrl"
          frameborder="0"
        ></iframe>
        <template v-else>
          <iframe
            width="100%"
            height="100%"
            :src="currentValue.newAttaUrl"
            frameborder="0"
            v-if="isZip"
          ></iframe>
          <div v-else>
            <p v-if="isShow && currentValue.downloadFlag==1">请点击“下载”，下载 “{{ currentValue.name }}” 到本地。</p>
            <p v-else>该压缩文件无法预览</p>
          </div>
        </template>
      </template>
    </div>
    <!-- 视频 -->
    <div class="contentItem" v-else-if="currentValue.szrtType === 4">
      <video
        class="video-js status_1_content_resouce"
        controls
        preload="auto"
        controlslist="nodownload"
        data-setup="{'example_option':true}"
        ref="newCourseVideo"
        @play="videoPlay"
        @ended="endVideo"
      >
        <source
          :src="currentValue.newAttaUrl"
          type="video/mp4"
          class="video"
          @click="videoPlay"
        />
        <p class="vjs-no-js">不支持播放</p>
      </video>
    </div>
    <!-- 富文本 -->
    <div style="height: calc(100% - 70px);overflow: auto" class="type6style" id="type6style"
         v-else-if="currentValue.szrtType === 6"
         v-loading="renderLoading">
      <div>
        <div
          class="type6Item"
          :class="{ jyxClass: courseId == 3156 }"
          v-for="(item, index) in currentValue.imageText"
          :key="index"
          :ref="'scroll' + item.sort"
          :style="{
                  'text-align': item.styleOption? item.styleOption.textDecoration: 'left'
                  }"
        >
          <template v-if="item">
            <div class=" editorShowArea ql-editor" v-html="item.value" v-if="item.type === 1"></div>
            <questionRender
              v-else-if="item.type === 3"
              :question="item"
              :isShow="isShow"
              :questionAnswer="item.questionAnswer"
              @getQuestionAnswer="getQuestionAnswer(arguments[0], index)"
              @handleGoStudy="handleGoStudy">
            </questionRender>
            <!-- 链接 -->
            <div class="lianjie" v-else-if="item.type === 5">
              <span @click="openlianjie(item)">{{ item.name }}</span>
            </div>
            <el-image
              v-else-if="item.type === 7"
              :style="{
                  width: item.styleOption.width
                    ? item.styleOption.width + '%'
                    : '50%',
                }"
              class="type6resouce"
              :src="item.value"
              :preview-src-list="[item.value]">
            </el-image>
            <template v-else-if="item.type === 10">
              <div :ref="'zl_edit_video_line' + index"
                   :style="{ height: isFixed && playingIndex == index? videoShowHeight + 'px': 0}">
              </div>
              <video
                v-drag
                :class="{is_fixed: isFixed && playingIndex == index, noneStyle: !isFixed}"
                :style="{ 'width': isFixed && playingIndex == index? '400px': item.styleOption.width + '%' }"
                class="video-js type6resouce"
                controls
                preload="auto"
                controlslist="nodownload"
                data-setup="{'example_option':true}"
                @play="videoPlayItem(item, index)"
                @ended="endVideoItem"
                :ref="'zl_edit_video' + index"
              >
                <source :src="item.value" type="video/mp4" class="video"/>
                <p class="vjs-no-js">不支持播放</p>
              </video>
            </template>

            <code-compiler
              :readPage="true"
              ref="codeCompiler"
              readOnly
              :refresh="item.value"
              v-else-if="item.type === 11"
              v-model="item.value"
            ></code-compiler>
            <div v-else-if="item.type === 12">
              <el-popover
                placement="bottom"
                trigger="click"
              >
                <span class="zl_button zl_blueButton" @click="handleImport(item.value)">下 载</span>
                <el-button size="mini" slot="reference">{{ item.name || item.value }}</el-button>
              </el-popover>
            </div>

            <!-- pdf -->
            <iframe v-else-if="item.type == 110"
              style="width: 100%;height: 450px;"
              :src=" pptIframe + item.value"
              frameborder="0"
            ></iframe>

            <div v-if="isShow && currentValue.taskType == 1" style="margin-top: 7px">
              <div
                class="zl_button zl_blueButton"
                v-if="item.type === 11 && item.extendOption && item.extendOption.operationIsShow"
                @click="handleGoStudy(item)"
              >试一下
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 图片 -->
    <div class="contentItem" v-else-if="currentValue.szrtType === 7">
      <img class="status_1_content_resouce" :src="currentValue.newAttaUrl"/>
    </div>
    <!-- 试题 -->
    <div style="height: calc(100% - 42px);overflow: auto" v-else-if="currentValue.szrtType == 9">
      <div class="editorShowArea ql-editor" v-html="currentValue.content"></div>
    </div>

    <div class="new_course_render_test_wrap" v-else-if="currentValue.szrtType == 10">
      <div class="new_course_render_test_wrap_header">
        <span v-if="currentValue.name" style="padding-right: 10px">{{ currentValue.name }}</span>
        <span v-else-if="currentValue.tagName" style="padding-right: 10px">{{ currentValue.tagName }}</span>
        (测验)包含以下试题：
      </div>
      <ul>
        <li v-for="(item,key) in currentValue.testPaper.sections" :key="key">
          <p class="test_wrap_p">
            <span class="test_wrap_span1">{{ item.sectionAlias || item.sectionName }}</span>
            <span class="test_wrap_span2">{{ item.sectionScore }}分 · {{ item.questionCount }}题</span>
          </p>
          <img v-if="item.question[0].questionTypeId == 1" src="../../../../static/images/newCourse/dxuan.png"/>
          <img v-if="item.question[0].questionTypeId == 2" src="../../../../static/images/newCourse/duoxuan.png"/>
          <img v-if="item.question[0].questionTypeId == 3" src="../../../../static/images/newCourse/pdan.png"/>
          <img v-if="item.question[0].questionTypeId == 9" src="../../../../static/images/newCourse/shicao.png"/>
          <img v-if="item.question[0].questionTypeId == 5" src="../../../../static/images/newCourse/jianda.png"/>
          <img v-if="item.question[0].questionTypeId == 6" src="../../../../static/images/newCourse/zuhe.png"/>
          <img v-if="item.question[0].questionTypeId == 4" src="../../../../static/images/newCourse/tiankong.png"/>
          <img v-if="item.question[0].questionTypeId == 10" src="../../../../static/images/newCourse/fujian.png"/>
        </li>
      </ul>
      <div style="height: 20%;">

      </div>
    </div>
    <!-- 作业 -->
    <div class="currentValueName" v-else-if="currentValue.szrtType === 11">
      <span v-if="currentValue.name" style="padding-right: 10px">{{ currentValue.name }}</span>
      <div class="homeworkContent">
        <div class="details_left">
          <div class="workMatter editorShowArea ql-editor"
               v-html="currentValue.homeworkBaseJSON.homeworkContents[0].content"></div>
        </div>
        <div class="details_right">
          <div style="padding-top: 30px">
            <div
              class="fujian_box"
              :key="index"
              @mouseover="mouseover(index)"
              @mouseleave="mouseleave(index)"
              v-for="(item, index) in currentValue.homeworkBaseJSON.homeworkContents[0].attachment"
              :title="item.attachmentName"
            >
              <ToolTip
                :href="item.attachmentUrl"
                :name="item.attachmentName"
                :type="item.type"
                :id="item.id"
                :isShow="item.show"
                :xaizai='false'
              >
                {{ item.attachmentName }}
              </ToolTip>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 预览-->
    <!-- 视频 -->
    <video-preview :videoSrc="videoSrc" :videoName="videoName" v-if="videoSrc"
                   @closeFn="closeVideoPreview"></video-preview>
    <!-- 图片 -->
    <imgView v-if="imgSrc" :imgSrc="imgSrc" :imgName="imgName" @closeFn="closeImgview"></imgView>

    <!-- 组件循环调用，不要把图文预览的写到预览文件的本身里！！！！    -->
    <!--   在组件 imageTextView 调用了本页面，又在本页面调用 imageTextView ，递归调用报错 。  -->
    <!--  2022.3.39/19.02/王江龙   -->
    <!-- 图文预览 -->
    <!--    <imageTextView  v-if="imageTextObject && imageTextObject.type === 6" :imageTextObject="imageTextObject"></imageTextView>-->
    <!-- MP3预览 -->
    <audioView ref='audio' :audioSrc="audioSrc" :audioName="audioName" v-if="audioSrc"
               @closeFn="closeaudioView"></audioView>

  </div>
</template>
<!--
1 单选题
2 多选题
3 判断题
4 填空题
5 问答题
6 组合题
7 连线题
8 配伍选择题
9 操作题
10 附件题
-->
<script>
import questionRender from "../../component/questionRender";
import paperPreview from "../../component/paperPreview";
import codeCompiler from "../../component/code_compiler";
import bus from "../../../bus/bus";
import * as api from "../../../api/courseApi";
import * as testApi from "../../../api/testApi";
import operation from "../../component/operation";
import answer from "../../component/answer";
import Pagination from "../../szrt_revision/new_educa_module/educa/commonCom/pagination";
import videoPreview from "../../szrt_revision/components/videoPreview";
import imgView from "../../szrt_revision/new_course_module/editCourse/sourceMaterial/imgView";
import audioView from "../../szrt_revision/new_course_module/editCourse/sourceMaterial/audioView";
import ToolTip from "../../szrt_revision/teachingDetail/components/ToolTip";
// import imageTextView from "../../szrt_revision/new_course_module/editCourse/sourceMaterial/imageTextView";
import axios from 'axios'
import qs from 'qs'
import Zl_pdf from "@/components/zl_pdf";
import {Message} from "element-ui";
/* ppt */
import '../../../../static/ppt/js/jszip.min.js'
import '../../../../static/ppt/js/filereader.js'
import '../../../../static/ppt/js/jquery-1.11.3.min.js'
import '../../../../static/ppt/js/d3.min.js'
import '../../../../static/ppt/js/nv.d3.min.js'
import '../../../../static/ppt/js/pptxjs.js'
import '../../../../static/ppt/js/divs2slides.js'

var videoTop = -1, videoLeft = -1;

export default {
  name: "new_course_render",
  props: {

    showTopCurrentValueName: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    catalogId: {
      type: [String, Number],
      default: '',
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    isIT: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Zl_pdf,
    questionRender,
    paperPreview,
    codeCompiler,
    operation,
    answer,
    Pagination,
    videoPreview,
    imgView,
    // imageTextView,
    audioView,
    ToolTip
  },
  data() {
    return {
      projectType: process.env.NODE_ENV,
      currentValue: this.value,
      courseId: this.$route.query.courseId || this.$route.query.id,
      courseName: this.$route.query.courseName,
      classId: this.$route.query.classId,
      className: this.$route.query.className,
      classStatus: this.$route.query.classStatus,
      subjectId: this.$route.query.subjectId,
      catalogType: this.$route.query.catalogType,
      courseType: this.$route.query.courseType,
      type: this.$route.query.type,  //课程类型 ，2单项 3综合
      userType: sessionStorage.getItem('userType'),
      iframeUrl: "",
      optObject: {},
      //
      isStartTime: 0,
      isFinish: '../../../../static/images/newCourse/study/completed.png',//已完成图标
      unFinish: '../../../../static/images/newCourse/study/inprogress.png',//进行中图标
      questionIdList: [], // 图文中的试题ID集合， 查询是否答题的参数
      /* 试卷 */
      paperData: {},
      peperList: [],
      renderLoading: false,
      startTest: null,
      startTest1: null,
      examId: 0,
      score: 0,
      paperId: 0,
      isZip: false,
      renderHeight: window.innerHeight - 202,
      //
      isFixed: false,
      playingVideo: {},
      playingIndex: -1,
      videoShowHeight: 0,
      clientHeight: 0,
      rowData: '',
      tableData: [],
      loading: false,
      pageTotal: {
        //分页
        page: 1,
        pageSize: 10,
        total: 0,
      },
      // 预览
      audioSrc: "",
      audioName: "",
      videoSrc: "",
      videoName: "",
      imgSrc: "",
      imgName: "",
      imageTextObject: "",
      xaizai: false,

      pptIframe: process.env.PREVIEW_URL,
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val && Object.keys(val).length) {
          this.currentValue = {};
          this.pageTotal = {
            //分页
            page: 1,
            pageSize: 10,
            total: 0,
          }
          this.$nextTick(() => {
            this.currentValue = JSON.parse(JSON.stringify(val));
            if (val.szrtType === 1 || val.szrtType === 2 || val.szrtType === 8) {
              if (this.projectType === 'native' && val.szrtType === 1){
                console.log('----是本地部署的ppt文件展示-',val )
              }else{
                let that = this
                axios.post(`${process.env.UPLOAD_NAME}` + '/file/doesObjectExistZip', qs.stringify({filePath: this.currentValue.newAttaUrl}), {
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: 'bearer ' + localStorage.getItem('Authorization')
                  },
                }).then(res => {
                  if (res.data.code == 0) {
                    that.isZip = true
                  } else {
                    that.isZip = false
                  }
                }).catch(error => {
                  console.log(error);
                })

                this.iframeUrl = process.env.PREVIEW_URL + this.currentValue.newAttaUrl;
              }

            } else if (val.resourceType == 3) {
              val.show = val.show ? 1 : 0;
            } else if (val.resourceType == 5) {
              this.optObject = {
                id: this.courseId,
                paperId: this.currentValue.id,
              };
            } else if (val.szrtType == 6) {
              if (val.imageText && val.imageText.length) {
                this.questionIdList = [];
                [].forEach.call(val.imageText, imageText => {
                  if (imageText.type == 3 && imageText.value) {  // 试题
                    this.questionIdList.push(imageText.value)
                  } else if (imageText.type == 5 && imageText.value) { // 试卷测验
                    // this.renderLoading = true;
                    // this.getTehDate(imageText.value);
                  }
                })
                if (this.questionIdList.length) {
                  this.getQuestionAnswer()
                } else {
                  this.$emit('insertDirectory', 1)
                }
              }
            }
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {

    if (this.$route.query.query) {
      this.query = JSON.parse(this.$AES.AES_Decrypt(this.$route.query.query))
      this.courseId = this.query.id  //课程ID
      this.courseName = this.query.courseName  //课程ID
      this.subjectId = this.query.subjectId //课程ID
    }

    bus.$on('goIndexes', this.goIndexes)

  },
  destroyed() {
    if (typeof this.messageError === "function") {
      Message.error = this.messageError
    }
    clearInterval(this.intervalId)
  },
  methods: {
    handleScroll() {
      if (this.playingIndex >= 0) {
        let mydom = this.$refs['zl_edit_video' + this.playingIndex][0];
        let scrollTop = document.getElementById('type6style').scrollTop    // 滚动条偏移量
        let offsetTop = this.$refs['zl_edit_video_line' + this.playingIndex][0].offsetTop;  // 要滚动到顶部吸附的元素的偏移量
        this.isFixed = Math.floor(scrollTop) - Math.floor(offsetTop) - Math.floor(this.clientHeight) > 0 ? true : false;  // 如果滚动到顶部了，this.isFixed就为true
        if (this.isFixed) {
          if (videoLeft !== -1 && videoTop !== -1) {
            mydom.style.top = videoTop + 'px';
            mydom.style.left = videoLeft + 'px';
          } else {
            mydom.style.top = 'initial';
            mydom.style.left = 'initial';
          }

          this.videoShowHeight = this.clientHeight;
        } else {
          this.videoShowHeight = 0;
        }
      }

    },
    /*  图文中 视频播放开始 */
    videoPlayItem(item, index) {
      if (this.playingIndex === index) {
        return
      } else if (this.playingIndex !== -1) {
        let mydom = this.$refs['zl_edit_video' + this.playingIndex][0];
        mydom.style.top = 'initial';
        mydom.style.left = 'initial';
        mydom.pause()
      }
      videoLeft = -1;
      videoTop = -1;
      this.playingVideo = item;
      this.playingIndex = index;
      this.videoShowHeight = 0;
      this.isFixed = false;
      this.clientHeight = this.$refs['zl_edit_video' + this.playingIndex][0].clientHeight;
      document.getElementById('type6style').addEventListener('scroll', this.handleScroll) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理

    },
    endVideoItem() {
      videoLeft = -1;
      videoTop = -1;
      this.playingIndex = -1;
      this.videoShowHeight = 0;
      this.isFixed = false;
      document.getElementById('type6style').addEventListener('scroll', null)
    },
    goIndexes(o) {
      if (
        eval("this.$refs.scroll" + o.sort) &&
        eval("this.$refs.scroll" + o.sort).length
      ) {
        let length = eval("this.$refs.scroll" + o.sort).length;
        eval("this.$refs.scroll" + o.sort)[length - 1].scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "center", // 上边框与视窗顶部平齐。默认值
        });
      }
    },
    handleGoStudy(item, event) {
      this.$emit('handleGoStudy', item, event)
    },
    intoStuPreview(item) {
      this.$emit('intoStuPreview', item)
    },
    beginTest(item, n) {
      this.$emit('beginTest', item, n)
    },
    intoPreview(item,) {
      this.$emit('intoPreview', item)
    },
    /* 视频播放结束 */
    endVideo() {
      if (this.isShow) {
        let endTime = new Date().getTime();
        if (this.isStartTime && endTime - this.isStartTime > 5 * 1000) {
          let data = {
            ext: JSON.stringify(this.currentValue.newAttaUrl),
            "endTime": endTime,
            "routeUrl": process.env.BASE_API + this.$route.fullPath,
            "startTime": this.isStartTime,
            "time": Math.ceil((endTime - this.isStartTime) / 1000),
            "userId": window.sessionStorage.getItem('userId')
          }
          api.endVideo(data).then(() => {
          })
        }
        this.$emit('insertDirectory', 1)
      }
    },
    /* 视频播放开始 */
    videoPlay() {
      this.isStartTime = new Date().getTime();
    },

    // 获取图文中的答案
    getQuestionAnswer(id, i) {
      api.QueryAnswer({
        courseId: this.courseId,
        classId: this.classId,
        questionIds: this.questionIdList
      }).then(res => {
        if (res.code == 0) {
          let saveAnswer = [];
          if (res.data && res.data.length) {
            [].forEach.call(res.data, item => {
              if (item.version) {
                saveAnswer.push(item);
              }
              if (id && item.questionId && id === item.questionId) {
                this.$set(this.currentValue.imageText[i], 'questionAnswer', item);
              }
              // else {
              //   [].forEach.call(this.currentValue.imageText, (imageTextItem, imageTextIndex) =>{
              //     if(imageTextItem.value === item.questionId){
              //       this.$set(this.currentValue.imageText[imageTextIndex], 'questionAnswer', item);
              //     }
              //   })
              // }
            })
            if (saveAnswer.length === this.questionIdList.length) {
              this.$emit('insertDirectory', 1)
            }
          }

        }
      })
    },
    // 获取图文中的试卷
    getTehDate(paperId) {
      testApi.testPaper(paperId).then(res => {
        if (res.code == 0) {
          this.paperData = res.data;
          this.peperList = res.data.testPaperPartsList;
          this.getStartTest(paperId);
        }
      })
    },
    // 获取图文中试卷的 判断，考试作答，继续作答
    getStartTest(paperId) {
      let obj = {
        catalogId: this.catalogId,
        userId: sessionStorage.getItem("userId"),
        classId: this.classId,
        paperId: paperId,
        courseId: this.courseId
      };
      api.getStartTest(obj).then(res => {
        if (res.code === "0") {
          //根据uerType判断老师还是学生，学生显示开始作答按钮，老师显示进入测验按钮
          if (this.userType == 2) {
            this.startTest = res.data.status;
            this.startTest1 = res.data.status1;
            this.examId = res.data.examId;
            this.score = res.data.score;
          } else {
            this.startTest = "enter";
          }
          // 这里需要加一个 字段来判断重来一次
        }
      }).finally(() => {
        this.renderLoading = false;
      })
    },
    //是否允许查看答案
    selectViewAnswers(val) {
      let obj = {
        classId: this.classId,
        courseId: this.courseId,
        catalogId: this.catalogId,
        resourceId: this.currentValue.id,
        resourceType: 3,  // 实操题，3
        status: val,
      };
      api.isAnswers(obj).then(rs => {
        if (rs.code == 0) {
          this.$messageSuccess('设置成功')
          this.$emit('selectTaskShow')
        } else {
          this.$messageError(rs.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // IT 试题中设置的解析
    openReferenceAnswer() {
      this.$emit('openReferenceAnswer')
    },
    /* 新开页，查看IT评分 */
    openRatingDetails(){
      let param = {
        token: localStorage.getItem('Authorization'),
        classId: this.classId,
        courseId: this.courseId,
        id: this.currentValue.id,
        type: 'itpf',
        learningStyle: 'kzrt',
        examType: 4,
      }

      let harf = process.env.RESOURSE_URL + '/#/?' + qs.stringify(param);
      window.open( harf, '_blank');
    },
    openlianjie(item) {
      if (item.value) {
        window.open(item.value, '_blank');
      } else {
        this.$messageWarning('配置有误，请仔细检查')
      }
    },
    // 选中导入的文件，传给组件
    handleImport(url) {
      this.$downloadFun(url)
    },
    // table 共享资源操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 共享资源
    table_previewBtn(rowData) {
      console.log(rowData);
      /**
       * @param RowData.type : 1ppt，2文档（包含word和pdf）, 3音频，4视频，5链接，6图文，7图片，8其它
       */
      switch (rowData.type) {
        case 1:
        case 2:
        case 8: // 1-ppt, 2-文档（包含word和pdf）, 6-图文, 8-其它
          window.open(process.env.PREVIEW_URL + rowData.newAttaUrl );
          break;
        case 3: // 音频
          this.audioSrc = rowData.newAttaUrl;
          this.audioName = rowData.name;
          break;
        case 4: // 视频
          this.videoSrc = rowData.newAttaUrl;
          this.videoName = rowData.name;
          break;
        case 5: // 链接
          window.open(rowData.newAttaUrl);
          break;
        case 6: // 图文
          this.imageTextObject = rowData;
          this.$set(this.imageTextObject, 'imageText', JSON.parse(rowData.imageText));
          this.$set(this.imageTextObject, 'szrtType', rowData.type);
          break;
        case 7: // 图片
          this.imgSrc = rowData.newAttaUrl;
          this.imgName = rowData.name;
          break;
        default:
          break;
      }
    },
    closeVideoPreview() {//关闭视频预览
      this.videoSrc = ""
      this.videoName = ""
    },
    //关闭音频预览
    closeaudioView() {
      this.audioSrc = ""
      this.audioName = ""
    },
    // 关闭图片
    closeImgview() {
      this.imgSrc = ""
      this.imgName = ""
    },
    // 共享资源列表
    shareResourceList(type) {
      let param = {
        catalogId: this.catalogId,
        courseId: this.courseId,//课程id
        classId: this.classId,
        pageNum: this.pageTotal.page,
        pageSize: this.pageTotal.pageSize,
      }
      return api.shareResourceList(param).then(rs => {
        if (rs.code == 0) {
          this.tableData = rs.data.list;
          this.pageTotal.total = rs.data.total;
          if (type === 'parent' && rs.data.total && this.$parent.currentValue) {
            this.$parent.currentValue.push({tagName: '共享资源'})
            if (this.$parent.currentValue.length === 1) {
              this.$parent.switchTab(this.$parent.currentValue, 0)
            }
          }
        } else {
          this.$messageError(rs.msg)
        }
      })
    },

    // 共享资源下载
    table_downloadBtn(row) {
      let url = `${process.env.UPLOAD_NAME}/file/szrt/downloadFiles?id=` + row.categoryResourceId;
      this.$downloadFun(url)
    },
    // 分页
    handleCurrentChange(val, type) {
      if (type == 'pageSize') {
        this.pageTotal.pageSize = val.limit;
      } else {
        this.pageTotal.page = val.page;
      }
      this.shareResourceList();
    },
    mouseover(index) {
      this.currentValue.homeworkBaseJSON.homeworkContents[0].attachment = this.currentValue.homeworkBaseJSON.homeworkContents[0].attachment.map((val, ind) => {
        if (index == ind) {
          val.show = true;
        } else {
          val.show = false;
        }
        return val;
      });
    },
    mouseleave() {
      this.currentValue.homeworkBaseJSON.homeworkContents[0].attachment = this.currentValue.homeworkBaseJSON.homeworkContents[0].attachment.map((val, ind) => {
        val.show = false;
        return val;
      });
    },
  },
  //注册局部组件指令
  directives: {
    drag: function (el) {
      let dragBox = el; //获取当前元素
      let innerWidth = window.innerWidth,
        innerHeight = window.innerHeight;
      dragBox.onmousedown = (e) => {
        //算出鼠标相对元素的位置
        let disX = e.clientX - dragBox.offsetLeft,
          disY = e.clientY - dragBox.offsetTop,
          clientWidth = dragBox.clientWidth,
          clientHeight = dragBox.clientHeight;
        document.onmousemove = (e) => {
          //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          let left = e.clientX - disX;
          let top = e.clientY - disY;
          if (left < 0) left = 0;
          if (top < 0) top = 0;
          if (left + clientWidth > innerWidth) left = innerWidth - clientWidth;
          if (top + clientHeight > innerHeight) top = innerHeight - clientHeight;

          //移动当前元素
          dragBox.style.left = left + "px";
          dragBox.style.top = top + "px";
          videoLeft = left;
          videoTop = top;
        };
        document.onmouseup = () => {
          //鼠标弹起来的时候不再移动
          document.onmousemove = null;
          //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
          document.onmouseup = null;
        };
      };
    },
  },
};
</script>
<style>
  .jyxClass p,
  .jyxClass h1,
  .jyxClass h4,
  .jyxClass h3,
  .jyxClass h2{
    text-indent: 32px;
    white-space: initial;
  }
  .jyxClass p{
    font-size: 16px;
  }
  .jyxClass img{
    max-width: calc(100% - 33px);
  }
</style>
<style scoped lang="scss">
.is_fixed {
  position: fixed;
  top: initial;
  left: initial;
  bottom: 20px;
  right: 20px;
  z-index: 4000;
}

.noneStyle {
  top: 0px !important;
  left: 0px !important;
}


.new_course_render {
  width: 98%;
  padding: 0 1%;
  height: 100%;
  /*margin: 0 auto;*/
  position: relative;
  overflow: auto;

  .currentValueName {
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    color: #42414D;
    position: relative;

    .new_course_render_name{
      padding-right: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .is_finish {
      width: 16px;
      height: 16px;
    }

    .currentValueBtn {
      font-size: 12px;
      color: #42414D;
      position: absolute;
      right: 0px;
      top: 0px;
      display: flex;
      width: auto;
      white-space: nowrap;
    }

    .currentValueBtn2 {
      margin-left: 10px;
    }

    .item-table {
      width: 100%;

      .table {
        .empty_material {
          margin-top: 20px;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          img {
            width: 187px;
            height: 159px;
          }

          p {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #767484;
            margin: 0;
          }
        }
      }
    }
  }

  .workMatter {
    webkit-box-sizing: border-box;
    box-sizing: border-box;
    counter-reset: list-0;
    line-height: 1.42;
    /* height: 100%; */
    outline: none;
    overflow-y: auto;
    padding: 12px 15px;
    -o-tab-size: 4;
    tab-size: 4;
    -moz-tab-size: 4;
    text-align: left;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .contentItem {
    /*padding: 2%;*/
    /*height: 95%;*/
    background: #0D0D0D;
    width: 100%;
    height: calc(100% - 42px);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .status_1_content_resouce {
    display: inline-block;
    max-height: 100%;
    max-width: 100%;
  }

  .type6style {
    padding: 2% 10px 0 2%;
    max-width: 1100px;
    margin: 0 auto;

    .type6Item {
      margin-bottom: 7px;
      width: 100%;
      overflow: hidden;
    }

    .type6resouce {
      display: inline-block;
      max-width: 100%;
      /*max-height: 450px;*/
    }
  }

  .new_course_render_test_wrap {
    height: calc(100% - 41px);
    width: 100%;
    background: url("../../../../static/images/newCourse/paperbj.png") no-repeat bottom right;
    background-size: 50%;
    overflow-y: auto;

    .new_course_render_test_wrap_header {
      height: 20%;
      font-size: 20px;
      font-weight: 600;
      color: #42414D;
      display: flex;
      align-items: center;
      padding-left: 3%;
    }
  }

  .imageTextPeper,
  .new_course_render_test_wrap {
    ul {
      width: 100%;
      height: 60%;
      display: flex;
      flex-wrap: wrap;

      li {
        min-width: 188px;
        width: 22%;
        height: 35%;
        min-height: 120px;
        background: #FFFFFF;
        box-shadow: 0px 2px 18px 0px rgba(195, 184, 184, 0.2);
        position: relative;
        margin-left: 2%;
        margin-top: 2%;

        .test_wrap_p {
          position: absolute;
          top: 20%;
          left: 15%;

          .test_wrap_span1 {
            font-size: 20px;
            font-weight: 600;
            color: #42414D;
          }

          .test_wrap_span2 {
            font-size: 13px;
            color: #999999;
            display: block;
            margin-top: 15px;
          }
        }

        img {
          width: 65%;
          position: absolute;
          right: -12%;
          bottom: -20%;
        }
      }
    }
  }

  .homeworkContent {
    width: 100%;
    /*height: calc(100% - 20px);*/
    padding: 20px 30px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .details_left {
      width: 820px;
      height: 100%;
      line-height: 32px;
      text-indent: 30px;

      /deep/ tbody {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
      }

      /deep/ table td,
      /deep/ table th {
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
        padding: 0px 5px;
        text-align: center;
      }
    }

    .details_right {
      width: 200px;
      min-height: 100%;
      overflow-y: auto;
      text-align: left;

      .fujian_box {
        display: inline-block;
        min-width: 120px;
        font-size: 12px;
        color: #2B2A33;
        height: 30px;
        line-height: 30px;
        /*text-indent: 30px;*/
        padding-right: 10px;
        margin-bottom: 10px;
        border-radius: 4px;
        word-break: break-all;
        white-space: nowrap;
        text-overflow: ellipsis;

        img {
          width: 14px;
          height: 14px;
        }
      }

      /deep/ .fujian_box .tips {
        /*padding: 10px 20px;*/
        background: url('../../../../static/images/tooltip.png') no-repeat center/100%;
        position: absolute;
        top: -33px;
        left: 47%;
        color: #fff;
        margin-left: -55px;
        display: -webkit-box;
        display: -ms-flexbox;
      }

      .fujian_box > div:hover {
        color: #1890FF;
      }
    }
  }

  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 0; /*高宽分别对应横竖滚动条的尺寸*/
    height: 0;
  }

  .lianjie {
    padding: 12px 15px;
    text-decoration: underline;
    color: blue;

    span {
      cursor: pointer;
    }
  }

  .showFileStyle{
    padding: 0 20px;
    height: calc(100% - 42px);
    color: #ffffff;
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: center;*/
    overflow: auto;
  }

}
</style>
<style>
.el-popover {
  min-width: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/new_course_editor/components/new_course_render.vue